import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AuthService } from 'app/services/auth.service';
import { Loggable } from 'app/utils/logging/loggable';
import User from 'entity/User';
import UserController from 'rest/UserController';

export interface ModalNameData {
  modalTitle: string;
  user: User;
}

@Component({
  selector: 'app-modal-name',
  templateUrl: './modal-name.component.html',
  styleUrls: ['./modal-name.component.scss'],
  standalone: false,
})
export class ModalNameComponent extends Loggable implements OnInit {
  private user: User;
  private formBuilder = new UntypedFormBuilder();

  public formGroup?: UntypedFormGroup;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalNameData,
    public dialogRef: MatDialogRef<ModalNameComponent>,
    private authService: AuthService,
  ) {
    super();
    this.setDisplayName('ModalNameComponent');
    dialogRef.disableClose = true;
    this.user = data.user;
  }

  public ngOnInit(): void {
    this.setFormGroup();
  }

  private setFormGroup(): void {
    this.formGroup = this.formBuilder.group({
      firstName: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
      lastName: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
    });
  }

  private noWhitespaceValidator(control: AbstractControl): null | { whitespace: boolean } {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  public async updateUser(): Promise<void> {
    const controls = this.formGroup?.controls;

    const updatedUser = {
      ...this.user,
      firstName: controls?.firstName.value,
      lastName: controls?.lastName.value,
    };

    try {
      const newUser = await new UserController().updateUser(updatedUser);
      this.user = newUser;
      this.authService.setUser(newUser);
      this.confirmButtonClicked();
    } catch (e) {
      this.error('Error Updating User', { e });
    }
  }

  private confirmButtonClicked(): void {
    this.dialogRef.close('primary');
  }
}
